export default __webpack_public_path__ + "static/media/phone-page.3eecd7cf.jpg";